<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="recipe-listings-section" ref="section">
            <recipes-filter :categories="categories" :value="selectedCategories" @update="handleCategorySelection" />

            <recipe-list-section
                :recipes="recipes"
            />
        </div>
    </fade-up-animation>
</template>

<script>
    import RecipeListSection from '../RecipeListSection/RecipeListSection';
    import createPropProxy from '../../../lib/prop-proxies';
    import RecipesFilter from '../../molecules/RecipesFilter/RecipesFilter.vue';

    export default {
        name: 'recipe-listings-section',

        components: { RecipesFilter, RecipeListSection },

        props: {
            categories: {
                type: Array,
                default: () => ([]),
            },

            selectedCategories: {
                type: Array,
                default: () => ([]),
            },

            recipes: {
                type: Array,
                default: () => ([]),
            },
        },

        computed: {
            /**
             * Create selectedCategoriesProxy.
             *
             * @returns {object}
             */
            ...createPropProxy(['selectedCategories']),
        },

        methods: {
            /**
             * When the categories are updated, proxy them up to the parent component.
             *
             * @param {string[]} categories
             */
            handleCategorySelection(categories) {
                this.selectedCategoriesProxy = [
                    ...categories,
                ];
            },
        },
    };
</script>

<style lang="scss" scoped>
    .recipes-filter {
        margin-bottom: 30px;
    }
</style>
